function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 16C7 16.5523 7.44772 17 8 17C8.55228 17 9 16.5523 9 16V14C9 13.4477 8.55228 13 8 13C7.44772 13 7 13.4477 7 14V16Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 17C11.4477 17 11 16.5523 11 16V8C11 7.44771 11.4477 7 12 7C12.5523 7 13 7.44771 13 8V16C13 16.5523 12.5523 17 12 17Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15 16C15 16.5523 15.4477 17 16 17C16.5523 17 17 16.5523 17 16V10C17 9.44772 16.5523 9 16 9C15.4477 9 15 9.44772 15 10V16Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V5ZM4 5H20V19H4V5Z"
});

function SvgMyProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#908E8E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProgress);
export default __webpack_public_path__ + "static/media/my-progress.c3ab0b00.svg";
export { ForwardRef as ReactComponent };